interface ArticleLegalBasis {
  legalBasisType?: unknown;
  legalBasisTypeValidFrom?: Date | null;
}

export function mustBeSentToP1(
  article: ArticleLegalBasis | null | undefined,
  judgmentDate: Date | null | undefined,
): boolean {
  if (!article?.legalBasisType) {
    return false;
  }
  if (!article.legalBasisTypeValidFrom) {
    return true;
  }
  if (!judgmentDate) {
    return false;
  }
  const judgmentDay = new Date(judgmentDate);
  judgmentDay.setHours(0, 0, 0, 0);
  const validFrom = new Date(article.legalBasisTypeValidFrom);
  validFrom.setHours(0, 0, 0, 0);
  return judgmentDay >= validFrom;
}
